// B3 - Workflow engine mocks

export interface WorkflowDef {
  id: string
  code: string
  name: string
  category: 'flight-plan' | 'logistics' | 'medical' | 'transport' | 'incident' | 'admin'
  version: string
  steps: number
  avgSlaHours: number
  status: 'active' | 'draft' | 'archived'
  instances: number
}

export interface WorkflowInstance {
  id: string
  defCode: string
  defName: string
  refCode: string
  initiator: string
  startedAt: string
  currentStep: string
  currentLevel: number
  totalLevels: number
  slaRemainingH: number
  slaTotalH: number
  status: 'running' | 'waiting' | 'completed' | 'rejected' | 'overdue'
  priority: 'low' | 'normal' | 'high' | 'critical'
}

export interface WorkflowTask {
  id: string
  instanceId: string
  instanceRef: string
  title: string
  assignee: string
  assignedAt: string
  dueAt: string
  slaHoursLeft: number
  action: 'approve' | 'review' | 'sign' | 'execute' | 'verify'
  priority: 'low' | 'normal' | 'high' | 'critical'
  fromUser: string
}

export const WORKFLOW_DEFS: WorkflowDef[] = [
  { id: 'wf-1', code: 'WF-KHB-3CAP', name: 'Phê duyệt KHB 3 cấp', category: 'flight-plan', version: 'v2.1', steps: 5, avgSlaHours: 18, status: 'active', instances: 240 },
  { id: 'wf-2', code: 'WF-KHB-4CAP', name: 'Phê duyệt KHB tác chiến 4 cấp', category: 'flight-plan', version: 'v1.4', steps: 7, avgSlaHours: 24, status: 'active', instances: 78 },
  { id: 'wf-3', code: 'WF-VK-XUAT', name: 'Xuất kho vũ khí', category: 'logistics', version: 'v1.2', steps: 4, avgSlaHours: 6, status: 'active', instances: 156 },
  { id: 'wf-4', code: 'WF-NL-CAPPHAT', name: 'Cấp phát nhiên liệu', category: 'logistics', version: 'v1.0', steps: 3, avgSlaHours: 2, status: 'active', instances: 920 },
  { id: 'wf-5', code: 'WF-YT-CERT', name: 'Cấp giấy phép bay y tế', category: 'medical', version: 'v1.1', steps: 5, avgSlaHours: 48, status: 'active', instances: 86 },
  { id: 'wf-6', code: 'WF-VT-KH', name: 'KH vận chuyển HKQS', category: 'transport', version: 'v1.0', steps: 4, avgSlaHours: 12, status: 'active', instances: 124 },
  { id: 'wf-7', code: 'WF-INC-ATB', name: 'Báo cáo sự cố ATB', category: 'incident', version: 'v2.0', steps: 6, avgSlaHours: 24, status: 'active', instances: 18 },
  { id: 'wf-8', code: 'WF-AD-USER', name: 'Onboarding tài khoản', category: 'admin', version: 'v1.3', steps: 5, avgSlaHours: 8, status: 'active', instances: 42 },
  { id: 'wf-9', code: 'WF-AD-ROLE', name: 'Yêu cầu cấp quyền', category: 'admin', version: 'v1.0', steps: 3, avgSlaHours: 4, status: 'active', instances: 68 },
  { id: 'wf-10', code: 'WF-OLD-KHB', name: 'Phê duyệt KHB (cũ)', category: 'flight-plan', version: 'v1.0', steps: 4, avgSlaHours: 24, status: 'archived', instances: 1240 },
]

const INSTANCES_RAW: Array<[string, string, string, number, number, number, number, WorkflowInstance['status'], WorkflowInstance['priority']]> = [
  ['WF-KHB-3CAP', 'KHB-2026-0145', 'Đ.uý Lê V.C', 1, 3, 14, 18, 'running', 'high'],
  ['WF-KHB-3CAP', 'KHB-2026-0146', 'Th.uý Vũ V.D', 2, 3, 8, 18, 'running', 'normal'],
  ['WF-KHB-3CAP', 'KHB-2026-0147', 'Tr.uý Bùi V.E', 0, 3, 17, 18, 'waiting', 'normal'],
  ['WF-VK-XUAT', 'XK-2026-0145', 'Đ.uý Lê V.C', 1, 4, 4, 6, 'running', 'high'],
  ['WF-VK-XUAT', 'XK-2026-0144', 'Th.tá Phạm V.A', 3, 4, 2, 6, 'running', 'critical'],
  ['WF-NL-CAPPHAT', 'CP-2026-0840', 'Th.uý Vũ V.D', 2, 3, 1, 2, 'running', 'normal'],
  ['WF-YT-CERT', 'GP-YT-2026-0146', 'BS Nguyễn V.A', 2, 5, 36, 48, 'running', 'normal'],
  ['WF-YT-CERT', 'GP-YT-2026-0145', 'BS Trần T.B', 4, 5, 12, 48, 'running', 'high'],
  ['WF-VT-KH', 'VT-2026-0089', 'Đ.uý Hoàng V.F', 1, 4, 8, 12, 'running', 'normal'],
  ['WF-INC-ATB', 'INC-2026-0089', 'Th.tá Trần V.E', 5, 6, 6, 24, 'running', 'critical'],
  ['WF-AD-USER', 'OB-2026-0042', 'Tr.t Nguyễn V.A', 3, 5, 6, 8, 'running', 'normal'],
  ['WF-KHB-3CAP', 'KHB-2026-0140', 'Đ.uý Lê V.C', 3, 3, 0, 18, 'completed', 'normal'],
  ['WF-VK-XUAT', 'XK-2026-0143', 'Th.tá Phạm V.A', 4, 4, 0, 6, 'completed', 'normal'],
  ['WF-KHB-3CAP', 'KHB-2026-0138', 'Tr.uý Bùi V.E', 1, 3, -2, 18, 'overdue', 'high'],
  ['WF-AD-ROLE', 'AR-2026-0124', 'Th.uý Hoàng V.G', 2, 3, 0, 4, 'rejected', 'normal'],
]

export const WORKFLOW_INSTANCES: WorkflowInstance[] = INSTANCES_RAW.map(([def, ref, init, cur, total, slaRem, slaT, st, pr], i) => {
  const wf = WORKFLOW_DEFS.find((w) => w.code === def)!
  return {
    id: `wfi-${i + 1}`,
    defCode: def,
    defName: wf.name,
    refCode: ref,
    initiator: init,
    startedAt: `2026-05-${String(3 + (i % 4)).padStart(2, '0')} ${String(8 + (i % 8)).padStart(2, '0')}:${String((i * 13) % 60).padStart(2, '0')}`,
    currentStep: cur === total ? 'Hoàn tất' : cur === 0 ? 'Chờ khởi động' : `Bước ${cur} / ${total}`,
    currentLevel: cur,
    totalLevels: total,
    slaRemainingH: slaRem,
    slaTotalH: slaT,
    status: st,
    priority: pr,
  }
})

export const WORKFLOW_TASKS: WorkflowTask[] = [
  { id: 'tk-1', instanceId: 'wfi-1', instanceRef: 'KHB-2026-0145', title: 'Duyệt KHB cấp Sư đoàn', assignee: 'Đ.tá Trần Q.F', assignedAt: '08:30', dueAt: '12:30', slaHoursLeft: 4, action: 'approve', priority: 'high', fromUser: 'Đ.uý Lê V.C' },
  { id: 'tk-2', instanceId: 'wfi-2', instanceRef: 'KHB-2026-0146', title: 'Duyệt KHB cấp Trung đoàn', assignee: 'Tr.tá Phạm V.A', assignedAt: '07:50', dueAt: '13:50', slaHoursLeft: 6, action: 'approve', priority: 'normal', fromUser: 'Th.uý Vũ V.D' },
  { id: 'tk-3', instanceId: 'wfi-4', instanceRef: 'XK-2026-0145', title: 'Kiểm vũ khí trước cấp phát', assignee: 'Th.tá Nguyễn V.B', assignedAt: '08:00', dueAt: '10:00', slaHoursLeft: 2, action: 'verify', priority: 'high', fromUser: 'Đ.uý Lê V.C' },
  { id: 'tk-4', instanceId: 'wfi-5', instanceRef: 'XK-2026-0144', title: 'Cấp phát R-77 cho KHB-0145', assignee: 'Tr.uý Bùi V.E', assignedAt: '08:42', dueAt: '10:42', slaHoursLeft: 2, action: 'execute', priority: 'critical', fromUser: 'Th.tá Phạm V.A' },
  { id: 'tk-5', instanceId: 'wfi-7', instanceRef: 'GP-YT-2026-0146', title: 'BS HK ký quyết định y tế', assignee: 'BS Nguyễn V.A', assignedAt: '07:00', dueAt: '15:00', slaHoursLeft: 8, action: 'sign', priority: 'normal', fromUser: 'Phi công PC-2024-001' },
  { id: 'tk-6', instanceId: 'wfi-10', instanceRef: 'INC-2026-0089', title: 'Phê duyệt báo cáo sự cố ATB', assignee: 'Đ.tá Trần V.F', assignedAt: '06:00', dueAt: '12:00', slaHoursLeft: 6, action: 'approve', priority: 'critical', fromUser: 'Th.tá Trần V.E' },
  { id: 'tk-7', instanceId: 'wfi-11', instanceRef: 'OB-2026-0042', title: 'Tạo tài khoản hệ thống cho Th.uý mới', assignee: 'Th.tá Hoàng V.M', assignedAt: '08:00', dueAt: '14:00', slaHoursLeft: 6, action: 'execute', priority: 'normal', fromUser: 'Tr.t Nguyễn V.A' },
  { id: 'tk-8', instanceId: 'wfi-3', instanceRef: 'KHB-2026-0147', title: 'Duyệt KHB cấp Tiểu đoàn', assignee: 'Đ.uý Phạm Q.M', assignedAt: '09:05', dueAt: '11:05', slaHoursLeft: 17, action: 'approve', priority: 'normal', fromUser: 'Tr.uý Bùi V.E' },
]

export const WORKFLOW_KPIS = {
  defs: WORKFLOW_DEFS.length,
  activeDefs: WORKFLOW_DEFS.filter((w) => w.status === 'active').length,
  totalInstances: WORKFLOW_DEFS.reduce((s, w) => s + w.instances, 0),
  runningNow: WORKFLOW_INSTANCES.filter((i) => i.status === 'running').length,
  overdue: WORKFLOW_INSTANCES.filter((i) => i.status === 'overdue').length,
  pendingTasks: WORKFLOW_TASKS.length,
  myTasks: WORKFLOW_TASKS.filter((t) => t.priority === 'critical' || t.priority === 'high').length,
}
